export default __webpack_public_path__ + "static/media/work-one.66bd620c.PNG";